module.exports = __webpack_public_path__ + "static/media/125.55ca71ab.png";